// extracted by mini-css-extract-plugin
export default {"rating":"_G-z","numberOfStars":"aH-z","count":"bH-z","barGraphSpacing":"cH-z","barGraph":"dH-z"};